import server from '@/utils/request';

// Get accessible menus for current user (already in English)
export const getMenuTree_api = (data: object) => server.post(`/menu/_all/tree`, data);

export const queryOwnThree = (data: any) => server.post<any>('/menu/user-own/tree', data)
/**
 * Validate code uniqueness
 * @param data - The data containing code to validate
 */
export const validCode_api = (data:object) => server.get(`/menu/code/_validate`,data);


// Get asset types (already in English)
export const getAssetsType_api = () => server.post(`/menu/asset-types`);
// Get menu details (already in English)
export const getMenuInfo_api = (id:string) => server.get(`/menu/${id}`);
// Edit menu information (already in English)
export const saveMenuInfo_api = (data: object) => server.patch(`/menu`, data);
// Add menu information (already in English)
export const addMenuInfo_api = (data: object) => server.post(`/menu`, data);
// Delete menu information (already in English)
export const delMenuInfo_api = (id: string) => server.remove(`/menu/${id}`);

// Get all operation guides (already in English)
export const getDeviceMsg = () => server.post(`/app/device/getDeviceMsg`, {pageIndex: 0, pageSize: 999});
